import React from "react";
import "./style.css";

export default function SecurityCard1({logo,heading,description,status}) {
    return(
        <div className="security_card">
            <span className={`active_state  ${status === 1? 'active' :'inactive'}`}>{status === 1? "Activated":"Inactive"}</span>
            <img src={logo} className="logo_header" />
            <h2>{heading}</h2>
            <p>{description}</p>
        </div>
    )
}